<template>
  <div  v-loading="metaLoading" class="pageBox">
    <div class="hello" v-if="!metaLoading&&apiMeta">
      <div class="title titleFlex">
        <div>
          <span>{{ apiMeta.path }}</span>
          <span v-if="apiMeta.status == '0'" class="TitleStauts">维护中</span>
        </div>
        <el-button @click="goBuy(apiMeta.id)" type="primary" v-if="apiMeta.fee_way == 0||apiMeta.fee_way == 1||apiMeta.fee_way == 3">立即购买</el-button>
      </div>
      <div class="title">{{ apiMeta.title }}</div>
      <div class="update-time">
        <span>更新时间:{{ apiMeta.last_time || apiMeta.add_time }}</span>
      </div>
      <div style="margin-top: 16px">
        <template v-if="apiMeta.fee_way == '0'">
          <el-link type="primary">增值api</el-link
          ><span style="margin: 0 3px">｜</span>
          <el-link type="primary">按次收费</el-link>
        </template>
        <template v-if="apiMeta.fee_way == '1'">
          <el-link type="primary">增值api</el-link
          ><span style="margin: 0 3px">｜</span>
          <el-link type="primary">一次性收费</el-link>
        </template>
        <template v-if="apiMeta.fee_way == '3'">
          <el-link type="primary">增值api</el-link
          ><span style="margin: 0 3px">｜</span>
          <el-link type="primary">按年收费</el-link>
        </template>
        <template v-if="apiMeta.fee_way == '2'">
          <el-link type="primary">免费api</el-link
          ><span style="margin: 0 3px">｜</span>
          <el-link type="primary">直接调用</el-link>
        </template>
      </div>
      <p class="info">{{ apiMeta.desc }}</p>
      <el-divider></el-divider>

      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item name="1">
          <template slot="title">
            <p class="param-title">公共参数</p>
          </template>
          <p class="param-sub-title">
            请求地址（目前只提供正式环境，暂无沙箱环境）
          </p>
          <el-table
            :data="apiMeta.common"
            style="width: 100%; margin-bottom: 20px"
            row-key="title"
            border
            default-expand-all
            :tree-props="{ children: 'sub' }"
          >
            <el-table-column prop="title" label="环境" sortable width="180">
            </el-table-column>
            <el-table-column
              prop="http_url"
              label="http地址"
              sortable
              width="180"
            >
            </el-table-column>
            <el-table-column prop="https_url" label="https地址">
            </el-table-column>
          </el-table>
          <p class="param-sub-title">公共请求参数</p>
          <el-table
            :data="apiMeta.common_param"
            style="width: 100%; margin-bottom: 20px"
            row-key="name"
            border
            default-expand-all
            :tree-props="{ children: 'sub' }"
          >
            <el-table-column prop="name" label="参数名称" sortable width="180">
            </el-table-column>
            <el-table-column prop="type" label="参数类型" sortable width="180">
            </el-table-column>
            <el-table-column prop="required" label="是否必填">
            </el-table-column>
            <el-table-column label="参数描述">
              <template slot-scope="scope">
                <span class="wrap" v-html="scope.row.desc"></span>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <p class="param-title">请求参数说明</p>
          </template>
          <el-table
            :data="apiMeta.request"
            style="width: 100%; margin-bottom: 20px"
            row-key="name"
            border
            default-expand-all
            :tree-props="{ children: 'sub' }"
          >
            <el-table-column prop="name" label="参数名称" sortable width="180">
            </el-table-column>

            <el-table-column prop="type" label="参数类型" sortable width="180">
            </el-table-column>
            <el-table-column prop="required" label="是否必填">
            </el-table-column>
            <el-table-column prop="code" label="示例" sortable width="180">
            </el-table-column>
            <el-table-column label="参数描述">
              <template slot-scope="scope">
                <span class="wrap" v-html="scope.row.desc"></span>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <p class="param-title">返回参数说明</p>
          </template>
          <el-table
            :data="apiMeta.response"
            style="width: 100%; margin-bottom: 20px"
            row-key="name"
            border
            default-expand-all
            :tree-props="{ children: 'sub' }"
          >
            <el-table-column prop="name" label="参数名称" width="180">
            </el-table-column>
            <el-table-column prop="type" label="参数类型" width="180">
            </el-table-column>
            <el-table-column prop="code" label="示例" width="180">
            </el-table-column>
            <el-table-column prop="desc" label="说明"> </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <p class="param-title">返回参数示例</p>
          </template>
          <JsonEditor ref="jsonEditor" v-model="apiMeta.response_code" />
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-empty v-else-if="!metaLoading&&!apiMeta" description="暂无API详情" />
  </div>
</template>

<script>
import JsonEditor from '../tool/JsonEditor'
import apis from '@/api/apis'

export default {
  components: {
    JsonEditor,
  },
  name: 'apiDocumentDetail',
  data() {
    return {
      collapse3Opend: false,
      cmOptions: {
        value: '',
        mode: 'application/json',
        theme: 'rubyblue',
        readOnly: true,
        lint: true,
      },
      activeNames: ['2', '3', '4'],
      apiMeta: null,
      metaLoading:false
    }
  },

  created() {
    this.getApiDetail()
  },
  methods: {
    goBuy(id){
      this.$router.push({name:'MyInterface',query:{buyApiId: id}})
    },
    getApiDetail() {
      this.metaLoading = true
      const params = this.$route.params
      if (!params.id) {
        return
      }
      apis.apiDocument.getArticle({ aid: params.id }).then((res) => {
        this.apiMeta = res.data
        // document.getElementById('title').innerHTML = this.apiMeta.title + ' - 微客云集'
        document.title = this.apiMeta.title + ' - 微客云集'
      })
      .finally(()=>{
        this.metaLoading = false
      })
    },
    handleChange(val) {
      if (val.indexOf(3) != -1 && this.collapse3Opend == false) {
        this.$refs.jsonEditor.refresh()
        this.collapse3Opend = true
      }
    },
  },
  watch: {
    '$route.params.id'() {
      this.getApiDetail()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
::v-deep.el-collapse {
  border-top: none;
  border-bottom: none;
  .el-collapse-item__header {
    border: none;
  }
}
::v-deep .wrap a {
  color: #0b4ffc;
  text-decoration: underline;
}

.hello {
  background-color: #fff;
  padding: 24px;
  height: 100%;
  .title {
    font-size: 32px;
    font-weight: 500;
    color: #1e1e28;
    /* line-height: 30px; */
    text-align: left;
    display: flex;
    align-items: center;
    .TitleStauts {
      margin-left: 15px;
      // display: block;
      line-height: 30px;
      font-size: 16px;
      color: red;
    }
  }
  .update-time {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    margin-top: 8px;
  }
  .info {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    margin-top: 16px;
  }
  .param-title {
    font-size: 24px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 33px;
    margin: 23px 0 16px;
  }
  .param-sub-title {
    font-size: 18px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
    margin: 16px 0 8px;
  }
}
.pageBox{
  min-height: 300px;
}
.titleFlex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
